import { render, staticRenderFns } from "./EditProperty.vue?vue&type=template&id=4d6b4178&scoped=true"
import script from "./EditProperty.vue?vue&type=script&lang=js"
export * from "./EditProperty.vue?vue&type=script&lang=js"
import style0 from "./EditProperty.vue?vue&type=style&index=0&id=4d6b4178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b4178",
  null
  
)

export default component.exports